import { useEffect } from "react";

import styles from "../styles/units.module.scss";

import { Title } from "../shared/components/Title";
import { Empty } from "../shared/components/Empty";
import { Button } from "../shared/components/Button";
import { Drawer } from "../shared/components/Drawer";
import { Icon } from "../shared/components/core/Icon";
import { useState } from "react";
import { Input } from "../shared/components/Input";
import { Checkbox } from "../shared/components/Checkbox";

import { EnvironmentsAPI } from "../providers/EnvironmentsAPI";
import { Loading } from "../shared/components/Loading";

export default function Units() {
	const [visible, setDrawerVisible] = useState(false);
	const [loadingUnits, setLoadingUnits] = useState(true);
	const [loading, setLoading] = useState(false);
	const [units, setUnits] = useState([]);
	const [active, setActive] = useState('');
	const [name, setName] = useState('')
	const [unitId, setUnitId] = useState('')
	const [editMode, setEditMode] = useState(false)
	const [helpdeskContact, setHelpDeskContact] = useState({});

	useEffect(
		() => {
			const loadData = async () => {
				setLoadingUnits(true);
				const id = window.location.href.split('/')[5];
				const response = await EnvironmentsAPI.getUnits(String(id))
				const units = response.getData({})['units']
				setUnits(units)
				setLoadingUnits(false);
			};
			loadData();
		}, []
	)


	const addNewUnit = () => {
		setDrawerVisible(true)
		setEditMode(false)
		setName('')
	}

	const handleEditUnit = async () => {

		setLoading(true);
		setUnits([])

		const response = await EnvironmentsAPI.putUnit(unitId, { name, alias: name.split(" ").join("").toLocaleLowerCase(), type: 'UNIT', active })
		const data = response.getData({})
		
		if (data.id) {
			await EnvironmentsAPI.putConfigurationsByAlias(
				data.id,
				'helpdesk_contact',
				helpdeskContact
			);
		}

		setTimeout(() => {
			const unitEdit = units
			unitEdit.forEach((item, index) => {
				if (item.id === unitId) {
					unitEdit[index] = { name: data.name, alias: data.alias, id: data.id, avatarUrl: data.avatarUrl, active: data.active, type: 'UNIT' }
				}
			})
			setTimeout(setUnits(unitEdit), 200)
			setLoading(false);
			setDrawerVisible(false);
			setName('');
			setHelpDeskContact({});
		}, [2000]);
	};
	
	const handleSubmit = async () => {

		const id = window.location.href.split('/')[5];
		setLoading(true);
		
		const response = await EnvironmentsAPI.postUnit(id, { name, alias: name.split(" ").join(""), type: 'UNIT', active: true })
		const data = response.getData({})
		if (data.id) {
			await EnvironmentsAPI.putConfigurationsByAlias(
				data.id,
				'helpdesk_contact',
				helpdeskContact
			);
		}

		setTimeout(() => {
			setUnits([...units, response.getData({})]);
			setName("");
			setHelpDeskContact({});
			setLoading(false);
			setDrawerVisible(false);
		}, [500]);
	};

	const toggleUnitStatus = async (index) => {
		setLoadingUnits(true);
		const updatedUnits = Array.from(units);

		const response = await EnvironmentsAPI.putUnit(updatedUnits[index].id, {
			name: updatedUnits[index].name,
			alias: updatedUnits[index].name.split(" ").join("").toLocaleLowerCase(),
			type: 'UNIT',
			active: !updatedUnits[index].active
		})

		setTimeout(() => {
			const data = response.getData({})
			updatedUnits[index].active = data.active;
			setUnits(updatedUnits);
			setLoadingUnits(false);
		}, 500);
	};

	const editUnit = async (unit) => {
		setName(unit.name)
		setUnitId(unit.id)
		setActive(unit.active)
		
		const helpdesk = await EnvironmentsAPI.getConfigurationsByAlias(unit.id, 'helpdesk_contact');
		setHelpDeskContact(helpdesk);

		setEditMode(true)
		setDrawerVisible(true)
	};

	return (
		<div className={styles.unitsContainer}>
			<Title
				title="Unidades"
				backTo={{ url: "/configuracoes/marcas", name: "Marcas" }}
			>
				{units?.length > 0 && (
					<Button design="primary" onClick={() => addNewUnit()} add>
						Adicionar unidade
					</Button>
				)}
			</Title>
			{
				loadingUnits && (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							position: "absolute",
							minWidth: "-webkit-fill-available",
							minHeight: "-webkit-fill-available",
						}}
					>
						<Loading />
					</div>
				)
			}

			{!loadingUnits && (
				!units?.length && !loading ? (
					<Empty>
						<Icon name="store" size="4x" />
						<p>Você ainda não possui unidades</p>
						<span>
							Através desta ferramenta, você pode registrar suas unidades.
						</span>
						<Button design="primary" onClick={() => setDrawerVisible(true)}>
							Adicionar unidade
						</Button>
					</Empty>
				) : (
					<div className={styles.units}>
						{units.map((unit, index) => {
							return (
								<div className={styles.unit} key={index}>
									<div className="d-flex flex-column align-start">
										<p className={styles.name}>{unit.name}</p>
										<Checkbox
											name={`status-${index}`}
											checked={unit.active}
											onChange={() => toggleUnitStatus(index)}
										>
											Plataforma ativada
										</Checkbox>
									</div>
									<div>
										<Button
											design="default-icon-mini"
											onClick={() => editUnit(unit)}
										>
											<Icon name="pen" size="sm" />
										</Button>
									</div>
								</div>
							);
						})}
					</div>
				)
			)}

			<Drawer
				visible={visible}
				onClose={() => setDrawerVisible(false)}
				title={`${editMode ? 'Editar' : 'Adicionar'} unidade`}
				footer={
					<Button
						design="primary"
						className="w-100"
						disabled={!name.length > 0}
						loading={loading}
						onClick={editMode ? handleEditUnit : handleSubmit}
					>
						Salvar
					</Button>
				}
			>
				<Input
					design="two"
					value={name}
					floatLabel="Nome da unidade"
					className="mb-20"
					onChange={(e) => setName(e.target.value)}
				/>
				<Input
					design="two"
					value={helpdeskContact?.email}
					className="mb-20"
					floatLabel="E-mail"
					onChange={(e) => setHelpDeskContact({ ...helpdeskContact, email: e.target.value })}
				/>
				<Input
					design="two"
					value={helpdeskContact?.phone}
					className="mb-20"
					floatLabel="Telefone"
					type="tel"
					mask='(99) 99999-9999'
					onChange={(e) => setHelpDeskContact({ ...helpdeskContact, phone: e.target.value })}
				/>
				<Input
					design="two"
					value={helpdeskContact?.whatsapp_phone}
					className="mb-20"
					floatLabel="Whatsapp"
					type="tel"
					mask='(99) 99999-9999'
					onChange={(e) => setHelpDeskContact({ ...helpdeskContact, whatsapp_phone: e.target.value })}
				/>
			</Drawer>
		</div>
	);
}
